import React, { Component } from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { getTextColorsFromSection } from '../lib/colors';
import Grid, { GridItem } from '../Grid';
import Section, { SectionTitle } from '../Section';
import GridDialog from './GridDialog';
import Button from '../Button';

class GridSection extends Component {
  static propTypes = {
    event: PropTypes.object.isRequired,
    site: PropTypes.object.isRequired,
    section: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired,
    hideTitle: PropTypes.bool,
    imageRatio: PropTypes.number,
    placeholder: PropTypes.string,
  };

  static defaultProps = {
    hideTitle: false,
    imageRatio: 1,
    placeholder: undefined,
  };

  constructor(props) {
    super(props);
    this.state = {
      itemsHaveDescription: this.itemsHaveDescription(),
      selectedItem: {},
      dialogOpen: false,
      showAllItems: false,
    };
  }

  componentWillReceiveProps({ section }) {
    if (section.data.items !== this.props.section.data.items) {
      this.setState({ itemsHaveDescription: this.itemsHaveDescription() });
    }
  }

  openDialog = item => this.setState({ selectedItem: item, dialogOpen: true });

  closeDialog = () => this.setState({ dialogOpen: false });

  itemsHaveDescription = () => {
    const items = this.props.section.data.items;
    return Boolean(
      Array.isArray(items) && items.length && items.some(item => Boolean(item.description)),
    );
  };

  onToggleListLimit = () => this.setState({ showAllItems: !this.state.showAllItems });

  render() {
    const {
      event,
      site,
      section,
      classes,
      hideTitle,
      imageRatio,
      placeholder,
      ...other
    } = this.props;
    if (!section.data.items) {
      return null;
    }
    const { data, styles } = section;
    const { itemsHaveDescription, selectedItem, dialogOpen, showAllItems } = this.state;

    const colors = getTextColorsFromSection(site, section);

    const { summarizeItems, summarySize, buttons } = data;

    const currentButton = buttons && buttons[showAllItems ? 1 : 0];

    return (
      <Section site={site} section={section} withPadding withOpenDialog={dialogOpen} {...other}>
        {data.title && (
          <SectionTitle title={data.title} style={{ ...colors.title, ...styles.title }} />
        )}
        <Grid>
          {data.items.map(
            ({ id, ...item }, i) =>
              (!summarizeItems || showAllItems || i < summarySize) && (
                <GridItem
                  key={id || i}
                  data={item}
                  onClick={itemsHaveDescription && (() => this.openDialog(item))}
                  textColors={colors}
                  styles={section.styles}
                  hideTitle={hideTitle}
                  imageRatio={imageRatio}
                  placeholder={placeholder}
                  {...styles.grid}
                />
              ),
          )}
        </Grid>
        <div className={classes.centered}>
          {summarizeItems && currentButton && (
            <Button
              event={event}
              site={site}
              section={section}
              button={currentButton}
              style={styles.buttons[showAllItems ? 1 : 0]}
              onClick={this.onToggleListLimit}
            >
              {currentButton.title}
            </Button>
          )}
        </div>
        {itemsHaveDescription && (
          <GridDialog
            {...styles.grid}
            data={selectedItem}
            open={dialogOpen}
            onRequestClose={this.closeDialog}
          />
        )}
      </Section>
    );
  }
}

const stylesheet = {
  centered: {
    textAlign: 'center',
  },
};

export default injectSheet(stylesheet)(GridSection);



// WEBPACK FOOTER //
// ./src/site-render/src/GridSection/GridSection.js